import { useClientInfo } from "atoms/clientsAtom";
import { ClientDate } from "types";
import moment from "moment";
import classNames from "classnames";

import { NamedCounter } from "components/NamedCounter/NamedCounter";
import { Row } from "components/Row/Row";
import { Paragraph } from "components/Paragraph/Paragraph";
import { Checkbox } from "components/Checkbox/Checkbox";
import { AppSelect } from "components/Select/Select";
import { MediumText } from "components/MediumText/MediumText";
import { RegularText } from "components/RegularText/RegularText";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import styles from "../../styles.module.css";

type Props = {
  clientDate: ClientDate;
};

export function TableRow({ clientDate }: Props) {
  const { setClientInfoState, clientInfoState } = useClientInfo();

  const handleRowClick = () => {
    setClientInfoState((prev) => ({
      ...prev,
      selectedMarketingId:
        prev.selectedMarketingId === clientDate.clientdateid
          ? ""
          : clientDate.clientdateid,
    }));
  };

  return (
    <Row
      className={styles.row}
      onClick={handleRowClick}
      isActive={clientInfoState.selectedMarketingId === clientDate.clientdateid}
    >
      <div
        className={classNames(
          "flex flex-1 gap-6 items-center bg-inherit" as any,
          styles.table_row
        )}
        style={{ paddingBlock: "10px" }}
      >
        <Paragraph
          style={{ width: "22px", display: "flex", minWidth: "22px" }}
          className={styles.table_body_column}
        >
          {clientDate.clientdateid}
        </Paragraph>
        <Paragraph
          style={{ width: "132px", display: "flex", minWidth: "132px" }}
          className={styles.table_body_column}
        >
          {clientDate.name}
        </Paragraph>
        <Paragraph
          style={{ width: "125px", display: "flex", minWidth: "125px" }}
          className={styles.table_body_column}
        >
          {moment(clientDate.date).format("DD.MM.YYYY")}
        </Paragraph>
        <Paragraph
          style={{ width: "55px", display: "flex", minWidth: "55px" }}
          className={styles.table_body_column}
        >
          {clientDate.bonus}
        </Paragraph>
        <Paragraph
          style={{ width: "150px", display: "flex", minWidth: "150px" }}
          className={styles.table_body_column}
        >
          {clientDate.plusbonus}
        </Paragraph>
        <Paragraph
          style={{ width: "70px", display: "flex", minWidth: "70px" }}
          className={styles.table_body_column}
        >
          {clientDate.pluspercent}
        </Paragraph>
        <Paragraph
          style={{
            width: "240px",
            minWidth: "240px",
            display: "flex",
            alignItems: "center",
            columnGap: "6px",
          }}
          className={styles.table_body_column}
        >
          <MediumText size={12}>до:&nbsp;</MediumText>
          <RegularText size={14}>{clientDate.radiusminus}</RegularText>
          <HorizontalSpace size={61} />
          <MediumText size={12}>после:&nbsp;</MediumText>
          <RegularText size={14}>{clientDate.radiusplus}</RegularText>
        </Paragraph>
        <Paragraph
          style={{ width: "52px", display: "flex", minWidth: "52px" }}
          className={styles.table_body_column}
        >
          <Checkbox disabled checked={!!clientDate.burnday} />
        </Paragraph>
        <Paragraph
          style={{ width: "130px", display: "flex", minWidth: "130px" }}
          className={styles.table_body_column}
        >
          <Checkbox disabled checked={!!clientDate.useonce} />
        </Paragraph>
        <Paragraph
          style={{ width: "60px", display: "flex", minWidth: "60px" }}
          className={styles.table_body_column}
        >
          <Checkbox disabled checked={!!clientDate.domessage} />
        </Paragraph>
        <Paragraph
          style={{ width: "166px", display: "flex", minWidth: "166px" }}
          className={styles.table_body_column}
        >
          <AppSelect
            options={[]}
            placeholder="Шаблон СМС"
            className={styles.sms_select}
            isDisabled
            value={null}
            // smstextid
          />
        </Paragraph>
        <Paragraph
          style={{
            width: "145px",
            display: "flex",
            alignItems: "center",
            columnGap: "6px",
            minWidth: "145px",
          }}
          className={styles.table_body_column}
        >
          <span>за</span>
          <RegularText size={14}>{clientDate.rememberday}</RegularText>
          <span>дней</span>
        </Paragraph>
      </div>
    </Row>
  );
}
